import { invoiceExampleCatalog } from "./catalog";
import type { InvoiceExampleCatalogEntry, InvoiceImportSource } from "./types";

export function catalogImportSource(entry: InvoiceExampleCatalogEntry): InvoiceImportSource {
  return {
    kind: "catalog",
    filename: entry.filename,
    url: entry.url,
  };
}

export function uploadImportSource(filename: string): InvoiceImportSource {
  return {
    kind: "upload",
    filename,
  };
}

export function listCatalogSources(): InvoiceImportSource[] {
  return invoiceExampleCatalog.map(catalogImportSource);
}

export async function loadPdfBytes(source: InvoiceImportSource, uploadBytes?: ArrayBuffer): Promise<ArrayBuffer> {
  if (source.kind === "upload") {
    if (!uploadBytes) throw new Error(`Upload data missing for ${source.filename}.`);
    return uploadBytes;
  }
  if (!source.url) throw new Error(`Catalog URL missing for ${source.filename}.`);
  const response = await fetch(source.url);
  if (!response.ok) throw new Error(`Could not load PDF (${response.status}).`);
  return response.arrayBuffer();
}
